import { ErrorBase } from './ErrorBase'

export class TokenError extends ErrorBase {
  constructor({ message }: { message: string }) {
    super({ message })
    this.name = 'TokenError'
  }
}
